import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, Col, InputGroup, Modal, Button, Table } from 'react-bootstrap';
import Select from "react-dropdown-select";

import { siteActions } from '../../actions/scene/siteActions';
import { movieActions } from '../../actions/movie/movieActions';
import constants from '../../const';

function NewMovie(props) {
    var isMobile = window.innerWidth <= constants.mobileSize;
    const [show, setShow] = useState(false);
    const [validated, setValidated] = useState(false);
    const [firstTime, setFirstTime] = useState(true);
    const [movie, setMovie] = useState({
        site: 0,
        title: "",
        date: "2019-01-01",
        description: "",
        sceneNumber: 0
    })
    const [movies, setMovies] = useState([]);
    const [order, setOrder] = useState("asc");
    const [isVisible, setIsVisble] = useState(false);

    const normalizeMovies = (rawMovies) => {
        if (Array.isArray(rawMovies)) {
            return rawMovies;
        }
        if (rawMovies && Array.isArray(rawMovies.movies)) {
            return rawMovies.movies;
        }
        return [];
    }


    const refreshData = () => {
        props.getAllSite();
        props.getAllMovies();
    }
    const handleCancel = () => setShow(false);

    const handleSubmit = async (event) => {
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        await props.postMovie(movie);
        props.getAllMovies();
    }
    const handleShow = () => {
        setShow(true)
        props.getAllMovies();
        if (firstTime) {
            props.getAllSite();
            setFirstTime(false);
        }
    };

    useEffect(() => {
        setMovies(normalizeMovies(props.allMovie));
    }, [props.allMovie]);

    const sortMovies = (key) => {
        const nextOrder = order === "asc" ? "desc" : "asc";
        const sorted = [...movies].sort((a, b) => {
            const aVal = a?.[key];
            const bVal = b?.[key];
            if (aVal == null && bVal == null) return 0;
            if (aVal == null) return nextOrder === "asc" ? -1 : 1;
            if (bVal == null) return nextOrder === "asc" ? 1 : -1;
            if (typeof aVal === "number" && typeof bVal === "number") {
                return nextOrder === "asc" ? aVal - bVal : bVal - aVal;
            }
            return nextOrder === "asc"
                ? String(aVal).localeCompare(String(bVal))
                : String(bVal).localeCompare(String(aVal));
        });

        setOrder(nextOrder);
        setMovies(sorted);
    }

    return <>
        <Button variant="info" size={`${isMobile ? 'sm' : 'md'}`} onClick={handleShow}>Movie</Button>
        <Modal size="lg" show={show} onHide={handleCancel} style={{backgroundColor:'hsla(0, 0%, 0%, 0.9)'}}>
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                    <Modal.Title>New Movie Information</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ maxHeight: '70vh', overflowY: 'auto' }}>
                    <Form.Row>
                        <Form.Group as={Col} md="6" controlId="validationTitle">
                            <Form.Label htmlFor="inlineFormInputGroup" srOnly>Title</Form.Label>
                            <InputGroup size="sm">
                                <InputGroup.Prepend>
                                    <InputGroup.Text>Title</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control required type="text" placeholder="Title" defaultValue={movie.title} onChange={(e) => setMovie({ ...movie, title: e.target.value })} />
                                <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
                                <Form.Control.Feedback type="invalid">Please choose a valid Title</Form.Control.Feedback>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group as={Col} md="3" controlId="validationMinute">
                            <Form.Label htmlFor="inlineFormInputGroup" srOnly>Number of Scene</Form.Label>
                            <InputGroup size="sm">
                                <InputGroup.Prepend>
                                    <InputGroup.Text>Number of Scenes</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control type="text" placeholder="Minutes" defaultValue={movie.sceneNumber} onChange={(e) => setMovie({ ...movie, sceneNumber: e.target.value })} />
                            </InputGroup>
                        </Form.Group>
                    </Form.Row>
                    <Form.Row>
                        <Form.Group as={Col} md="6" controlId="validationSite">
                            <Form.Label htmlFor="inlineFormInputGroup" srOnly>Site</Form.Label>
                            <InputGroup size="sm">
                                <InputGroup.Prepend>
                                    <InputGroup.Text>Site</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Select style={{ minWidth: "300px" }} options={props.allSite} placeholder="+ click to select Site" labelField="name" valueField="id"
                                    color="#000000" searchable="true" sortBy="name" clearable="true" searchBy="name" dropdownHeight="250px" dropdownPosition="auto"
                                    values={[]} onChange={e => setMovie({ ...movie, site: e[0].id })} />
                            </InputGroup>
                        </Form.Group>

                        <Form.Group as={Col} md="6" controlId="validationCustom01">
                            <Form.Label htmlFor="inlineFormInputGroup" srOnly>Date</Form.Label>
                            <InputGroup size="sm">
                                <InputGroup.Prepend>
                                    <InputGroup.Text>Date (YYYY-MM-DD)</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control type="text" placeholder="date" defaultValue={movie.date} onChange={(e) => setMovie({ ...movie, date: e.target.value })} />
                            </InputGroup>
                        </Form.Group>

                    </Form.Row>
                    <Form.Row >
                        <Form.Group as={Col} md="12" controlId="validationCustom01">
                            <Form.Label htmlFor="inlineFormInputGroup" srOnly>Description</Form.Label>
                            <InputGroup size="sm">
                                <InputGroup.Prepend>
                                    <InputGroup.Text>Description</InputGroup.Text>
                                </InputGroup.Prepend>
                                <Form.Control style={{ height: "100px" }} as="textarea" aria-label="With textarea" defaultValue={movie.description} onChange={(e) => setMovie({ ...movie, description: e.target.value })} />
                            </InputGroup>
                        </Form.Group>
                    </Form.Row>

                    <Form.Row>
                        <Form.Group as={Col} md="12" className="mb-0">
                            <div className="d-flex justify-content-between align-items-center mt-2 mb-2">
                                <h6 className="mb-0">Existing Movies</h6>
                            </div>
                            <div style={{ width: '100%', overflowX: 'auto' }}>
                                <Table striped bordered hover size="sm" className="mb-0">
                                    <thead>
                                        <tr>
                                            <th onClick={() => sortMovies("id")}>#</th>
                                            <th onClick={() => sortMovies("title")}>Title</th>
                                            <th onClick={() => sortMovies("date")}>Date</th>
                                            <th onClick={() => sortMovies("site_name")}>Site</th>
                                            <th onClick={() => sortMovies("sceneNumber")}>Scenes</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {movies.map((item) => (
                                            <tr key={item.id}>
                                                <td>{item.id}</td>
                                                <td>{item.title}</td>
                                                <td>{item.date}</td>
                                                <td>{item.site_name || item.site || "-"}</td>
                                                <td>{item.sceneNumber || item.scene_number || 0}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            </div>
                        </Form.Group>
                    </Form.Row>

                </Modal.Body>
                <Modal.Footer>
                    <div className="mr-auto"> <Button className="mr-auto" variant="secondary" onClick={refreshData}>Refresh</Button></div>
                    <Button variant="secondary" onClick={handleCancel}>Cancel</Button>
                    <Button onClick={handleSubmit}>Save</Button>
                </Modal.Footer>
            </Form>
        </Modal>
    </>;
}

const mapStateToProps = (state) => {
    return {
        allSite: state.scenes.site.allSite,
        allMovie: state.movies.movies,
        error: state.scenes.status.error
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        getAllSite: () => dispatch(siteActions.getAllSite()),
        getAllMovies: () => dispatch(movieActions.getAllMovies()),
        postMovie: (movie) => dispatch(movieActions.postMovie(movie)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(NewMovie);